export default "__VITE_ASSET__bb97ebae__"